<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->



<template>

    <div class="sdev-layout">

        <Sidebar :open="sidebarOpen" @close="sidebarOpen = false" />

        <div class="sdev-layout-main">


            <Topbar @toggleSidebar="toggleSidebar" />

            <main class="sdev-content">

                <router-view v-slot="{ Component }">
                    <transition name="sdev-page" mode="out-in">
                        <component :is="Component" :key="$route.fullPath" />
                    </transition>
                </router-view>

            </main>

            <footer class="sdev-footer">

                <div class="sdev-footer-left"></div>

                <div class="sdev-footer-center sdev-brand-decoration"></div>

                <div class="sdev-footer-right sdev-brand-decoration"></div>

            </footer>

        </div>

    </div>

</template>

<script setup>

import { ref } from "vue"
import { useShortcuts } from "@/framework/bootstrap/useShortcuts"

const sidebarOpen = ref(true)

function toggleSidebar() {
    sidebarOpen.value = !sidebarOpen.value
}

const { register } = useShortcuts()

register("ctrl+b", () => {
    toggleSidebar()
})

</script>